// useUpdateDateRange.js
import { useEffect } from "react";
import dayjs from "../utils/dayjs";
import { periodMap, rangeMap } from "constants/datePeriods";

const getRange = (unit, rangeType, numberOfPeriod = 1) => {
  const now = dayjs();

  switch (rangeType) {
    case "current":
      return {
        fromDate: now.startOf(unit).toDate(),
        toDate: now.toDate(),
      };
    case "previous":
      return {
        fromDate: now.subtract(1, unit).startOf(unit).toDate(),
        toDate: now.subtract(1, unit).endOf(unit).toDate(),
      };
    case "custom":
      return {
        fromDate: now.subtract(numberOfPeriod, unit).startOf(unit).toDate(),
        toDate: now.toDate(),
      };

    default:
      return { fromDate: null, toDate: null };
  }
};

export function useUpdateDateRange(values, setValues) {
  useEffect(() => {
    const unit = periodMap[values.timePeriod];
    const rangeType = rangeMap[values.timeRange];

    if (unit && rangeType) {
      const { fromDate, toDate } = getRange(
        unit,
        rangeType,
        parseFloat(values.numberOfPeriod)
      );

      setValues((prev) => ({ ...prev, fromDate, toDate }));
    }
  }, [values.timePeriod, values.timeRange, values.numberOfPeriod, setValues]);
}
